import { AxiosResponse } from "axios";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { PaginatedResults } from "types/Query";
import { PaginationApiParams } from "@coolset/cs-ui";
import { SupportingInfo } from "../supportingInfo";

const getSupportingInfos = (
  params: { isParent?: boolean } & Partial<PaginationApiParams> = {}
): Promise<AxiosResponse<PaginatedResults<SupportingInfo.SupportingInfo>>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/supporting_information/`,
      method: "GET",
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<PaginatedResults<SupportingInfo.SupportingInfoApi>>) => {
    return {
      ...data,
      data: {
        ...data.data,
        results: data.data.results.map(camelizeObject<SupportingInfo.SupportingInfo>),
      },
    };
  });
};

const getSupportingInfo = (id: number | string): Promise<AxiosResponse<SupportingInfo.SupportingInfo>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/supporting_information/${id}/`,
      method: "GET",
    },
  }).then((data: AxiosResponse<SupportingInfo.SupportingInfoApi>) => {
    return camelizeObject(data);
  });
};

const createSupportingInfo = (
  params: SupportingInfo.CreateSupportingInfoParams
): Promise<AxiosResponse<SupportingInfo.SupportingInfo>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/supporting_information/`,
      method: "POST",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<SupportingInfo.SupportingInfoApi>) => {
    return camelizeObject(data);
  });
};

const updateSupportingInfo = (
  id: number | string,
  params: Partial<Omit<SupportingInfo.SupportingInfo, "id">>
): Promise<number | string> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/supporting_information/${id}/`,
      method: "PATCH",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<SupportingInfo.SupportingInfoApi>) => {
    return data.data.id;
  });
};

const deleteSupportingInfo = (id: number | string) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/supporting_information/${id}/`,
      method: "DELETE",
    },
  });
};

export const supportingInfoClient = {
  getSupportingInfos,
  getSupportingInfo,
  createSupportingInfo,
  updateSupportingInfo,
  deleteSupportingInfo,
};
